<template>
  <div class="product-listing-sort">
    <!-- Desktop Variant -->
    <div class="d-none d-lg-block">
      <button class="btn btn-link text-black w-100 d-flex align-items-center text-start my-3 border-0 fs-large fw-medium" data-bs-toggle="collapse" data-bs-target="#product-sort-list" aria-controls="product-sort-list" aria-expanded="false">
        <span class="product-listing-sort-label flex-fill">
          <slot name="product-sort-title"></slot>
        </span>
        <span class="product-listing-sort-current">{{ sorts.find((s) => s.value == currentQuery.sort).title }}</span>
      </button>
      <div class="collapse" id="product-sort-list">
        <form id="product-sort-form">
          <div v-for="(sort, index) in sorts" class="form-check">
            <input :id="'product-sort-' + index" class="form-check-input" type="radio" name="product-sort" :value="sort.value" v-model="currentQuery.sort"/>
            <label class="form-check-label" :for="'product-sort-' + index">
              {{ sort.title }}
            </label>
          </div>
        </form>
      </div>
    </div>

    <!-- Mobile Variant -->
    <div class="d-block d-lg-none">
      <button 
        class="btn btn-link bg-transparent text-black px-0 my-3" 
        data-bs-toggle="offcanvas" 
        data-bs-target="#product-sort-list-mobile" 
        aria-expanded="true" 
        aria-controls="product-sort-list-mobile"
      >
        <slot name="product-sort-mobile-title"></slot>
      </button>
      <div class="offcanvas offcanvas-end w-100" tabindex="-1" id="product-sort-list-mobile">
        <div class="offcanvas-header justify-content-end">
          <button type="button" class="btn-close mr-4" data-bs-dismiss="offcanvas" aria-label="Close">
            <slot name="offcanvas-close-button"></slot>
          </button>
        </div>
        <div class="offcanvas-body">
          <div class="offcanvas-panel-title">
            <strong class="h3">
              <slot name="product-sort-offcanvas-title"></slot>
            </strong>
          </div>
          <div class="offcanvas-panel-body pb-0">
            <form id="product-sort-form-mobile">
              <div v-for="(sort, index) in sorts" class="form-check">
                <input :id="'product-sort-mobile-' + index" class="form-check-input" type="radio" name="product-sort" :value="sort.value" v-model="currentQuery.sort"/>
                <label class="form-check-label" :for="'product-sort-mobile-' + index">
                  {{ sort.title }}
                </label>
              </div>
            </form>
            <div class="offcanvas-panel-footer">
              <button class="btn btn-primary w-100" data-bs-dismiss="offcanvas" aria-label="Close">
                <slot name="product-sort-apply"></slot>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['sorts', 'currentQuery']
  }
</script>